import * as React from "react";
import { Redirect } from "react-router-dom";
import Loader from 'react-loader';
import { toast, ToastContainer} from 'react-toastify';
import {Button,Col, Input, Modal, ModalBody, ModalHeader, Row} from 'reactstrap';
import Collapsible from 'react-collapsible';

import RecallInteraction from '../../../../components/RecallInteraction/RecallInteraction.Component';
import DragDropInteraction from '../../../../components/DnDInteraction/DragDropInteraction.Component';
import MultipleChoiceInteraction from '../../../../components/MultipleChoiceInteraction/MultipleChoiceInteraction.Component';
import MultipleChoiceMultiInteraction from '../../../../components/MultipleChoiceMultiInteraction/MultipleChoiceMultiInteraction.Component';
import { Wrapper, Content, ContentCol , ContentRow, ContentRowSingleCol, FormLabel, InputWrapper, TextArea} from './SingleInteraction.styles';
import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import withServices  from '../../../../HOCs/withServices';

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}
  
interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class SingleInteraction extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.updateInfo = this.updateInfo.bind(this);
        this.handleChange =  this.handleChange.bind(this);
        this.handleOPtionChange = this.handleOPtionChange.bind(this);
        this.handleOptionDelete = this.handleOptionDelete.bind(this);
        this.handleRecallWordChange = this.handleRecallWordChange.bind(this);
        this.handleChoiceChange = this.handleChoiceChange.bind(this);
        this.handleBoolChoiceChange = this.handleBoolChoiceChange.bind(this);
        this.handleChoiceDelete = this.handleChoiceDelete.bind(this);
        this.newChoice = this.newChoice.bind(this);
        this.newDnd = this.newDnd.bind(this);
        this.newRecallWord = this.newRecallWord.bind(this);
        this.handleRecallWordDelete = this.handleRecallWordDelete.bind(this);
        this.previewToggle = this.previewToggle.bind(this);
        this.interactionComplete = this.interactionComplete.bind(this);
    }

    public onGoBack() {
        const { history } = this.props;
        const dest = this.props.services.currentBaseUrl + 'interaction_set_list/' + this.state.data.interaction.interaction_set;
        
        console.log(dest)
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public handleOptionDelete(idx, options, e) {
        console.log(idx);
        
        options.splice(idx, 1);

        const data = this.state.data;

        data.interaction.options = options;

        this.setState({ data });
    }

    public handleChoiceDelete(idx, options, e) {
        console.log(idx);
        options.splice(idx, 1);

        const data = this.state.data;
    
        data.interaction.choice_answers = options;
    
        this.setState({ data });
    }

    public handleRecallWordDelete(idx, options, e) {
        console.log(idx);
        options.splice(idx, 1);

        const data = this.state.data;
    
        data.interaction.recall_words = options;
    
        this.setState({ data });
    }

    public newChoice(data, e) {
        const newchoice = {
            answer_text: 'answer text',
            is_correct_answer: false
        }

        data.interaction.choice_answers.push(newchoice);

        this.setState({ data });
    }

    public newDnd(data, e) {
        const newoption = {
            question: 'question text',
            answer: 'answer text',
            completion_text: 'completion text'
        }

        data.interaction.options.push(newoption);

        this.setState({ data });
    }

    public interactionComplete (data, e) {
        console.log('complete:' + e);
        this.previewToggle(data, e);
    }

    public redWordsProcessor(redwords) {

        let str = '';
        
        for (const redword of redwords) {
            str += redword.word + ','
        }

        return str.substring(0, str.length-1);
    }

    public previewToggle(data, e) {
        data.previewmodal = !data.previewmodal;

        console.log(data.previewmodal);

        this.setState({data});
    }

    public previewModal(data) {
        return (
            // tslint:disable-next-line jsx-no-lambda
            <Modal isOpen={data.previewmodal} toggle={(e) => this.previewToggle(data, e)} className="">
                {/*tslint:disable-next-line jsx-no-lambda*/}
                <ModalHeader toggle={(e) => this.previewToggle(data, e)}>Preview</ModalHeader>
                <ModalBody>
                    {this.previewInteraction(data)}
                </ModalBody>
            </Modal>
        );
    }
 
    public previewInteraction(data) {

        if(data.interaction.interaction_type === 'recall') {
            return(
                <div className="interaction-component-container">
                    <p className="interaction-type-title">Recall Interaction</p>
                    {/*tslint:disable-next-line jsx-no-lambda*/}
                    <RecallInteraction oncomplete={(e) => this.interactionComplete(data, e)} demomode={true} show={true} lessonid="1" interactionid="1" completiontext={data.interaction.completion_text} submittext={"Submit"} introtext={data.interaction.intro_text} question={data.interaction.paragraph_copy} redwords={this.redWordsProcessor(data.interaction.recall_words)} penalty={data.interaction.penalty} timelimit={data.interaction.time_limit}/>
                </div>
            );
        }
        if(data.interaction.interaction_type === 'draganddrop') {
            return(
                <div className="interaction-component-container">
                    <p className="interaction-type-title">Recall Interaction</p>
                    {/*tslint:disable-next-line jsx-no-lambda*/}
                    <DragDropInteraction oncomplete={(e) => this.interactionComplete(data, e)} demomode={true} show={true} lessonid="1" interactionid="1" completiontext={data.interaction.completion_text} submittext={"Submit"} introtext={data.interaction.intro_text}  dragquestions={data.interaction.options} penalty={data.interaction.penalty} timelimit={data.interaction.time_limit}/>
                </div>
            );
        }

        if(data.interaction.interaction_type === 'choice') {
            if (this.isMultiSelect(data)) {
                return(
                    <div className="interaction-component-container">
                        <p className="interaction-type-title">Recall Interaction</p>
                        {/*tslint:disable-next-line jsx-no-lambda*/}
                        <MultipleChoiceMultiInteraction oncomplete={(e) => this.interactionComplete(data, e)} demomode={true} show={true} lessonid="1" interactionid="1" completiontext={data.interaction.completion_text} submittext={"Submit"} introtext={data.interaction.intro_text}  question={data.interaction.question_text} penalty={data.interaction.penalty} answers={data.interaction.choice_answers} timelimit={data.interaction.time_limit}/>
                    </div>
                );
            }
            else{
                return(
                    <div className="interaction-component-container">
                        <p className="interaction-type-title">Recall Interaction</p>
                        {/*tslint:disable-next-line jsx-no-lambda*/}
                        <MultipleChoiceInteraction oncomplete={(e) => this.interactionComplete(data, e)} demomode={true} show={true} lessonid="1" interactionid="1" completiontext={data.interaction.completion_text} submittext={"Submit"} introtext={data.interaction.intro_text}  question={data.interaction.question_text} penalty={data.interaction.penalty} answers={data.interaction.choice_answers} timelimit={data.interaction.time_limit}/>
                    </div>
                );

            }
            
        }
        else{
            return (
                <p>No Interaction to display</p>
            );
        }
    }

    public isMultiSelect(data) {
        return data.interaction.choice_answers.filter((el)=> {
            return el.is_correct_answer;
          }).length > 1;
    }

    public newRecallWord(data, e) {
        const newrecall = {
            word: 'word',
            index: -1
        }

        data.interaction.recall_words.push(newrecall);

        this.setState({ data });
    }

    public dndInfo (data) {
        return (
            <div>
                <FormLabel htmlFor="questiontext" style={{ display: 'block' }}>
                                    Drag and Drop Questions
                </FormLabel>

                <Row>
                    <Col>
                        <h4>Questions</h4>
                    </Col>
                    <Col>
                        {/*tslint:disable-next-line jsx-no-lambda*/}
                        <Button onClick={(e) => this.newDnd(data, e)}>Add Drag & Drop</Button>
                    </Col>
                </Row><br/><br/>

                {this.dnDOptions(data.interaction.options)}
            
            </div>

        );
    }

    public dnDOptions(options) {
        return (
            
            options.map(
            (option, i) =>
            <Collapsible trigger={i+1 + '. '} key={option.id}>
            <li >
                <Row>
                    <Col>
                <FormLabel htmlFor="question" style={{ display: 'block' }}>
                    Question
                </FormLabel>
                {/*tslint:disable-next-line jsx-no-lambda*/}
                <TextArea  id="question" value={option.question} onChange= {(e) => this.handleOPtionChange(i, 'question' ,e)}/>

                <FormLabel htmlFor="answer" style={{ display: 'block' }}>
                    Answer
                </FormLabel>
                {/*tslint:disable-next-line jsx-no-lambda*/}
                <TextArea  id="answer" value={option.answer} onChange= {(e) => this.handleOPtionChange(i, 'answer' ,e)}/>

                <FormLabel htmlFor="completion" style={{ display: 'block' }}>
                    Completion Text
                </FormLabel>
                {/*tslint:disable-next-line jsx-no-lambda*/}
                <TextArea  id="question" value={option.completion_text} onChange= {(e) => this.handleOPtionChange(i, 'completion_text' ,e)}/>
                </Col>
                <Col>
                    {/*tslint:disable-next-line jsx-no-lambda*/}
                <Button onClick= {(e) => this.handleOptionDelete(i, options,e)}>Delete</Button>
                
                </Col>
                </Row>
                
            </li>
            </Collapsible>
            )
        );
    }

    public choiceOptions(options) {
        return (
            
            options.map(
            (option, i) =>
            <Collapsible trigger={i + 1 + '. '} key={option.id}>
            <li >
                <Row>
                    <Col>
                <FormLabel htmlFor="text" style={{ display: 'block' }}>
                    Text
                </FormLabel>
                {/*tslint:disable-next-line jsx-no-lambda*/}
                <TextArea  id="text" value={option.answer_text} onChange= {(e) => this.handleChoiceChange(i, 'answer_text' ,e)}/>

                <FormLabel htmlFor="answer" style={{ display: 'block' }}>
                    Is Correct Answer
                </FormLabel>
                {/*tslint:disable-next-line jsx-no-lambda*/}
                <input  id="answer" type="checkbox" value={option.is_correct_answer} checked={option.is_correct_answer} onChange= {(e) => this.handleBoolChoiceChange(i, 'is_correct_answer' ,e)}/>
                </Col>
                <Col>
                {/*tslint:disable-next-line jsx-no-lambda*/}
                <Button onClick= {(e) => this.handleChoiceDelete(i, options,e)}>Delete</Button>
                </Col>
                </Row>
            </li>
            </Collapsible>
            )
        );
    }

    

    public choiceInfo (data) {
        return (
            <div>
                <FormLabel htmlFor="questiontext" style={{ display: 'block' }}>
                                    Question Text
                </FormLabel>
                {/*tslint:disable-next-line jsx-no-lambda*/}
                <textarea rows={6} cols={38} id="questiontext" value={data.interaction.question_text} onChange= {(e) => this.handleChange('question_text', e)}/><br/><br/>
                <Row>
                    <Col>
                        <h4>Choice</h4>
                    </Col>
                    <Col>
                        {/*tslint:disable-next-line jsx-no-lambda*/}
                        <Button onClick={(e) => this.newChoice(data, e)}>Add Choice</Button>
                    </Col>
                </Row><br/><br/>
                
                {this.choiceOptions(data.interaction.choice_answers)}
            
            </div>

        );
    }

    public recallInfo (data) {
        return (
            <div>
                <FormLabel htmlFor="paragraph" style={{ display: 'block' }}>
                                    Paragraph Copy
                </FormLabel>
                {/*tslint:disable-next-line jsx-no-lambda*/}
                <textarea rows={6} cols={38} id="paragraph" value={data.interaction.paragraph_copy} onChange= {(e) => this.handleChange('paragraph_copy', e)}/>

                <Row>
                    <Col>
                    <h4>Recall Words</h4>
                    </Col>
                    <Col>
                        {/*tslint:disable-next-line jsx-no-lambda*/}
                        <Button onClick={(e) => this.newRecallWord(data, e)}>Add Word</Button>
                    </Col>
                </Row><br/><br/>

                
                {this.recallWords(data.interaction.recall_words)}
            
            </div>

        );
    }

    public recallWords(options) {
        return (
            
            options.map(
            (option, i) =>
            <Collapsible trigger={i+1 + '. '} key={option.id}>
            <li >
                <Row>
                <Col>
                <FormLabel htmlFor="word" style={{ display: 'block' }}>
                    Word
                </FormLabel>
                {/*tslint:disable-next-line jsx-no-lambda*/}
                <TextArea rows={6} cols={38}  id="word" value={option.word} onChange= {(e) => this.handleRecallWordChange(i, 'word' ,e)}/>
                <p>index: {this.state.data.interaction.paragraph_copy.indexOf(option.word)}</p>
                </Col>
                <Col>
                {/*tslint:disable-next-line jsx-no-lambda*/}
                <Button onClick= {(e) => this.handleRecallWordDelete(i, options,e)}>Delete</Button>
                </Col>
                </Row>
            </li>
            </Collapsible>
            )
        );
    }


    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const { params: { id: InteractionID } } = match;

        const InteractionInfoRes = await adminAPI.getSingleInteraction(InteractionID);

        if (InteractionInfoRes.ok) {
            
            const interaction = InteractionInfoRes.data;

            this.setState(
                {
                     data: {
                        interaction,
                        loaded: true,
                        previewmodal: false
                     }
                }
            )
        } else {
            toast.error('Error fetching interaction details!');
        }
    }

    public handleChange(id, e) {
        console.log(e)
        const data = this.state.data
        data.interaction[id] = e.target.value;
        this.setState({
            data
        });
    }

    public handleOPtionChange(id,field, e) {
        console.log(e)
        const data = this.state.data
        data.interaction.options[id][field] = e.target.value;
        this.setState({
            data
        });
    }

    public handleRecallWordChange(id,field, e) {
        console.log(e)
        const data = this.state.data
        data.interaction.recall_words[id][field] = e.target.value;
        this.setState({
            data
        });
    }

    public handleBoolChoiceChange(id,field, e) {
        console.log(e.target.value)
        const data = this.state.data
        data.interaction.choice_answers[id][field] = !data.interaction.choice_answers[id][field];
        this.setState({
            data
        });
    }

    public handleChoiceChange(id,field, e) {
        console.log(e.target.value)
        const data = this.state.data
        data.interaction.choice_answers[id][field] = e.target.value;
        this.setState({
            data
        });
    }

    public async updateInfo() {
        this.setState({
            loaded: false
        });

        const item = this.state.data.interaction;

        let type = '';

        if (item.interaction_type === 'draganddrop') {
            type = 'drag-and-drop';
        }

        else if (item.interaction_type === 'recall') {
            type = 'recall';
        }

        else if (item.interaction_type === 'choice') {
            type = 'choice';
        }

        const res = await this.props.services.adminAPI.updateInteractionBuilder(item, type, item.id);

        if (res.ok) {
            toast.success('Update Successful');
            this.setState({
                loaded: true
             });
        }
        else {
            toast.error('Update Failed');
            this.setState({
                loaded: true
             });
        }

        
    }

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </ContentRow>
              </Content>
              <Content>
              <Collapsible trigger={"General (" +data.interaction.interaction_type + ")"}>
                                          
                <Content>
                    <ContentRow>

                        <ContentCol>
                            <div>
                                <FormLabel htmlFor="title" style={{ display: 'block' }}>
                                    Title
                                </FormLabel>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <textarea rows={6} cols={38} id="title" value={data.interaction.name} onChange= {(e) => this.handleChange('name', e)}/>
                            </div>
                    
                        </ContentCol>

                        <ContentCol>
                            <div>
                                <FormLabel htmlFor="introtext" style={{ display: 'block' }}>
                                    Intro Text
                                </FormLabel>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <textarea rows={6} cols={38} id="introtext" value={data.interaction.intro_text} onChange= {(e) => this.handleChange('intro_text', e)}/>
                            </div>
                    
                        </ContentCol>

                    </ContentRow>
                    <ContentRow>

                        <ContentCol>
                            <div>
                                <FormLabel htmlFor="rangemin" style={{ display: 'block' }}>
                                    PQ Range Min
                                </FormLabel>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <input type="number"  id="rangemin" value={data.interaction.pq_range_min} onChange= {(e) => this.handleChange('pq_range_min', e)}/>
                            </div>
                    
                        </ContentCol>

                        <ContentCol>
                            <div>
                                <FormLabel htmlFor="rangemax" style={{ display: 'block' }}>
                                    PQ Range Max
                                </FormLabel>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <input type="number"  id="rangemax" value={data.interaction.pq_range_max} onChange= {(e) => this.handleChange('pq_range_max', e)}/>
                            </div>
                    
                        </ContentCol>

                        <ContentCol>
                            <div>
                                <FormLabel htmlFor="maxint" style={{ display: 'block' }}>
                                    Max per interaction
                                </FormLabel>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <input type="number" id="maxint" value={data.interaction.max_per_interaction} onChange= {(e) => this.handleChange('max_per_interaction', e)}/>
                            </div>
                    
                        </ContentCol>

                        <ContentCol>
                            <div>
                                <FormLabel htmlFor="minint" style={{ display: 'block' }}>
                                    Min per interaction
                                </FormLabel>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <input type="number" id="minint" value={data.interaction.min_per_interaction} onChange= {(e) => this.handleChange('min_per_interaction', e)}/>
                            </div>
                    
                        </ContentCol>

                        <ContentCol>
                            <div>
                                <FormLabel htmlFor="minint" style={{ display: 'block' }}>
                                    Penalty
                                </FormLabel>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <input type="number" id="minint" value={data.interaction.penalty} onChange= {(e) => this.handleChange('penalty', e)}/>
                            </div>
                    
                        </ContentCol>

                        <ContentCol>
                            <div>
                                <FormLabel htmlFor="timelimit" style={{ display: 'block' }}>
                                    Time Limit
                                </FormLabel>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <input type="number" id="timelimit" value={data.interaction.time_limit} onChange= {(e) => this.handleChange('time_limit', e)}/>
                            </div>
                    
                        </ContentCol>

                    </ContentRow>

                    <ContentRow>

                        
                        <ContentCol>
                            <div>
                                <FormLabel htmlFor="extratime" style={{ display: 'block' }}>
                                    Extra Time Required
                                </FormLabel>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <input type="number" id="extratime" value={data.interaction.extra_time_required} onChange= {(e) => this.handleChange('extra_time_required', e)}/>
                            </div>

                            <div>
                                <FormLabel htmlFor="difficulty" style={{ display: 'block' }}>
                                    Difficulty Level
                                </FormLabel>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <input min="1" max="5" type="range" id="difficulty" value={data.interaction.difficulty_level} onChange= {(e) => this.handleChange('difficulty_level', e)}/>
                            </div>
                    
                        </ContentCol>
                    </ContentRow>
                </Content>
              </Collapsible>

              </Content>

              <Content>
                <Collapsible trigger="Advanced">
                    {data.interaction.interaction_type==='draganddrop'?<ul>{this.dndInfo(data)}</ul>:<br/>}

                    {data.interaction.interaction_type==='recall'?<ul>{this.recallInfo(data)}</ul>:<br/>}

                    {data.interaction.interaction_type==='choice'?<ul>{this.choiceInfo(data)}</ul>:<br/>}
                </Collapsible>
              </Content>

              <Content>
              
                <ContentRow>
                    {this.previewModal(data)}
                  <div>
                    <Button onClick={this.updateInfo}>
                      Update
                    </Button>
                  </div>

                  <div>
                    {/*tslint:disable-next-line jsx-no-lambda*/}
                    <Button onClick={(e) => this.previewToggle(data, e)}>
                      Preview
                    </Button>
                  </div>
                </ContentRow>

              </Content>
            </Wrapper>    
        );
    
    }
}

export default withServices(SingleInteraction);


// WEBPACK FOOTER //
// ./src/pages/Admin/Interactions/SingleInteraction/SingleInteraction.tsx